"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;align-items:center;justify-content:center;background-color:", theme.color.primary.positive, ";color:", theme.color.monochrome.white, ";min-width:", (0, _util.rem)(169), ";border-radius:", (0, _util.rem)(6), ";padding:", (0, _util.rem)(4), ";padding-right:", (0, _util.rem)(8), ";position:fixed;left:", (0, _util.rem)(20), ";bottom:", (0, _util.rem)(20), ";transform:translateX(-125%);transition:transform 0.3s ease;z-index:2001;svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";margin-right:", (0, _util.rem)(4), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var show = process.env.NODE_ENV === "production" ? {
  name: "2ey0we",
  styles: "transform:translateX(0)"
} : {
  name: "1ddx8xm-show",
  styles: "transform:translateX(0);label:show;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  base: base,
  show: show
};
exports.styles = styles;
//# sourceMappingURL=Snackbar.styles.js.map